<template>
  <HeadlessDisclosure v-slot="{ open }" as="div">
    <Transition name="slide">
      <HeadlessDisclosurePanel :id="name" :class="$attrs.class">
        <slot></slot>
      </HeadlessDisclosurePanel>
    </Transition>

    <HeadlessDisclosureButton :id="name" as="template">
      <button
        class="text-left underline font-semibold flex gap-1 items-center"
        @click="handleToggle(open)"
      >
        {{ $t(`www.common.${open ? 'viewLess' : 'viewMore'}`) }}

        <WebccIcon
          :name="`site/${open ? 'chevron-up' : 'chevron-down'}`"
          class="h-4 w-4"
        />
      </button>
    </HeadlessDisclosureButton>
  </HeadlessDisclosure>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
}>()

const tracking = useTracking()

function handleToggle(open: boolean) {
  tracking.handlers?.redesignFilters.view(open, props.name)
}
</script>
